// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

/**
 * Redux Action types
 */
export enum ActionTypes {
    // App
    SAVE_APP_SETTINGS_SUCCESS = "SAVE_APP_SETTINGS_SUCCESS",
    ENSURE_SECURITY_TOKEN_SUCCESS = "ENSURE_SECURITY_TOKEN_SUCCESS",

    // Projects
    LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS",
    SAVE_PROJECT_SUCCESS = "SAVE_PROJECT_SUCCESS",
    DELETE_PROJECT_SUCCESS = "DELETE_PROJECT_SUCCESS",
    CLOSE_PROJECT_SUCCESS = "CLOSE_PROJECT_SUCCESS",
    LOAD_PROJECT_ASSETS_SUCCESS = "LOAD_PROJECT_ASSETS_SUCCESS",
    UPDATE_PROJECT_TAG_SUCCESS = "UPDATE_PROJECT_TAG_SUCCESS",
    UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS = "UPDATE_PROJECT_TAGS_FROM_FILES_SUCCESS",
    DELETE_PROJECT_TAG_SUCCESS = "DELETE_PROJECT_TAG_SUCCESS",
   // new
   UPDATE_TAG_LABEL_COUNTS_SUCCESS = "UPDATE_TAG_LABEL_COUNTS_SUCCESS",
   DELETE_PROJECT_ASSET_SUCCESS = "DELETE_PROJECT_ASSET_SUCCESS",
    // Connections
    LOAD_CONNECTION_SUCCESS = "LOAD_CONNECTION_SUCCESS",
    SAVE_CONNECTION_SUCCESS = "SAVE_CONNECTION_SUCCESS",
    DELETE_CONNECTION_SUCCESS = "DELETE_CONNECTION_SUCCESS",

    // Assets
    SAVE_ASSET_METADATA_SUCCESS = "SAVE_ASSET_METADATA_SUCCESS",
    LOAD_ASSET_METADATA_SUCCESS = "LOAD_ASSET_METADATA_SUCCESS",

    ANY_OTHER_ACTION = "ANY_OTHER_ACTION_SUCCESS",

    SHOW_ERROR = "SHOW_ERROR",
    CLEAR_ERROR = "CLEAR_ERROR",

    SET_TITLE = "SET_TITLE",

    // Models
    ALL_MODELS_SUCCESS = "ALL_MODELS_SUCCESS",
    DELETE_MODEL_SUCCESS = "DELETE_MODEL_SUCCESS",

    // Upload Docs
    UPLOAD_DOCS_DETAILS = "UPLOAD_DOCS_DETAILS",
    UPLOADED_FILE_STATUS = "UPLOADED_FILE_STATUS",
    UPLOADED_FILE_COUNT_INCREMENT = "UPLOADED_FILE_COUNT_INCREMENT",
    CLEAR_UPLOADED_FILES_COUNT_SUCCESS = "CLEAR_UPLOADED_FILES_COUNT_SUCCESS",
    UPLOADING_FILES_STATUS_SUCCESS = "UPLOADING_FILES_STATUS_SUCCESS",
    UPLOADING_FILES_STATUS_FAIL = "UPLOADING_FILES_STATUS_FAIL",
    CLEAR_EXISTING_MODEL_OCR_FILES_SUCCESS = "CLEAR_EXISTING_MODEL_OCR_FILES_SUCCESS",
    CLEAR_EXISTING_TEST_FILES_SUCCESS = "CLEAR_EXISTING_TEST_FILES_SUCCESS",
    // Load Blob Files
    LOAD_ALL_BLOB_FILES = "LOAD_ALL_BLOB_FILES",
    LOAD_TEST_ALL_FILES = "LOAD_TEST_ALL_FILES",
    DELETE_ASSET_SUCCESS = "DELETE_ASSET_SUCCESS",
    UPDATE_ASSET_STATE_SUCCESS = "UPDATE_ASSET_STATE_SUCCESS",
    UPDATE_ASSET_STATE_WITH_IMAGE_URI_SUCCESS = "UPDATE_ASSET_STATE_WITH_IMAGE_URI_SUCCESS",
    UPDATE_ASSET_WITH_BLOB_SUCCESS = "UPDATE_ASSET_WITH_BLOB_SUCCESS",
    // Delete files
    DELETE_FILES = "DELETE_FILES",

    // Batch prediction

    BATCH_PREDiCTION = "BATCH_PREDiCTION",

    // OPERATIONS
    CREATE_QUEUE_SUCCESS = "CREATE_QUEUE_SUCCESS",
    DELETE_USER_QUEUE_SUCCESS = "DELETE_USER_QUEUE_SUCCESS",
    LOAD_USER_ALL_QUEUE_SUCCESS = "LOAD_USER_ALL_QUEUE_SUCCESS",
    DOCUMENT_PREDICTION = "DOCUMENT_PREDICTION",

    // User defined Actions
    LOAD_ENDPOINTS = "LOAD_ENDPOINTS",
    CREATE_END_POINT = "CREATE_END_POINT",
    ENABLE_DISABLE_END_POINT = "ENABLE_DISABLE_END_POINT",
    DELETE_END_POINT = "DELETE_END_POINT",
    // Logged In User
    LOGGED_IN_USER = "LOGGED_IN_USER",
    LOGGED_OUT_USER = "LOGGED_OUT_USER",
    // OCR content
    LOAD_OCR_CONTENT_SUCCESS = "LOAD_OCR_CONTENT_SUCCESS",

    
    //projects -new
    EXPORT_PROJECT_SUCCESS = "EXPORT_PROJECT_SUCCESS",
    UPDATE_PROJECT_TRAIN_SUCCESS = "UPDATE_PROJECT_TRAIN_SUCCESS",
    
    
    //update project success
    UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS",


    //NEW 
    LOAD_OP_TEST_ALL_FILES ="LOAD_OP_TEST_ALL_FILES",
    CLEAR_EXISTING_OP_TEST_FILES_SUCCESS="CLEAR_EXISTING_OP_TEST_FILES_SUCCESS",
    DELETE_OP_TEST_ALL_FILES="DELETE_OP_TEST_ALL_FILES",


    UPDATE_PREBUILT_SETTINGS = "UPDATE_PREBUILT_SETTINGS",

    ADD_ASSET_TO_PROJECT_SUCCESS = "ADD_ASSET_TO_PROJECT_SUCCESS"

}
